// layout.component.ts
import {Component, inject, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SidebarComponent} from './sidebar/sidebar.component';
import {BreadcrumbComponent} from "./breadcrumb/breadcrumb.component";
import {StyleClass} from "primeng/styleclass";
import {Select} from "primeng/select";
import {FormsModule} from "@angular/forms";
import {UserContextService} from "../service/context/user-context.service";
import {User, UserLocationResponse} from "../feature/settings/users/interface/user";
import {UserService} from "../feature/settings/users/service/user.service";
import {MessageService, PrimeTemplate} from "primeng/api";
import {Toast} from "primeng/toast";
import {LocationList} from "../feature/settings/location/interface/location";

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [SidebarComponent, RouterModule, BreadcrumbComponent, StyleClass, Select, FormsModule, Toast, PrimeTemplate],
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {
  private _userContextService = inject(UserContextService);
  userService = inject(UserService);

  userLocations: UserLocationResponse[] = [];
  selectedUserLocation: UserLocationResponse | null = null;

  ngOnInit(): void {
    this._userContextService.user$.subscribe(user => {
      this.userLocations = user?.userLocations ?? [];

      if (!this.userLocations.length) {
        this.selectedUserLocation = null;
        this._userContextService.updateUserPrimaryLocation(null);
        return;
      }

      const stored = localStorage.getItem('selectedLocation');

      if (stored) {
        try {
          const saved = JSON.parse(stored);

          const location = this.userLocations.find(
            l => l.locationId === saved.locationId
          );

          if (location) {
            this.selectedUserLocation = location;
            this.updatePrimaryLocation(location);
            return;
          }
        } catch (error) {
          localStorage.removeItem('selectedLocation');
        }
      }

      const activeLocation = user?.activeLocation;

      if (activeLocation) {
        const location = this.userLocations.find(
          l => l.locationId === activeLocation.id
        );

        if (location) {
          this.selectedUserLocation = location;
          this.updatePrimaryLocation(location);
        }
      }
    });
  }

  onUserLocationChange(location: UserLocationResponse): void {
    this.selectedUserLocation = location;
    this.updatePrimaryLocation(location);
  }

  private updatePrimaryLocation(location: UserLocationResponse): void {
    this._userContextService.updateUserPrimaryLocation(
      location.isHeadquarter
        ? null
        : {
          id: location.locationId,
          name: location.locationName,
          isHeadquarter: false,
        } as LocationList
    );

    localStorage.setItem(
      'selectedLocation',
      JSON.stringify({
        locationId: location.locationId,
        locationName: location.locationName,
        isHeadquarter: location.isHeadquarter,
      })
    );
  }
}